import { createSlice } from "@reduxjs/toolkit";
import {
  getSalesSummaryCards,
  getSalesReferralLinkDetails,
  addSalesReferralLinkDetailsForLanguage,
  getSalesNetworkChart,
  getSalesRebateDetails,
} from "./thunk";

export const initialState = {
  // Get Summary Cards
  salesSummaryCardsData: [],
  salesSummaryCardsError: {},
  // Get Referral Link Details
  salesReferralLinkDetailsData: [],
  salesReferralLinkDetailsError: {},
  // Add Sales Referral Link Details For Language
  addSalesReferralLinkDetailsForLanguageData: [],
  addSalesReferralLinkDetailsForLanguageError: {},
  isSalesReferralLinkDetailsForLanguageSuccess: false,
  // Get Sales Network Info
  getSalesNetworkChartData: [],
  getSalesNetworkChartError: {},
  // Get Sales Rebate Details
  rebateSalesDetailsData: [],
  rebateSalesDetailsError: {},
};

const SalesDashboardReducer = createSlice({
  name: "SalesDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Sales Summary Cards
    builder.addCase(
      getSalesSummaryCards.fulfilled,
      (state: any, action: any) => {
        state.salesSummaryCardsData = action.payload;
      }
    );
    builder.addCase(
      getSalesSummaryCards.rejected,
      (state: any, action: any) => {
        state.salesSummaryCardsError = action.error.message;
      }
    );
    // Get Sales Referral Link Details
    builder.addCase(
      getSalesReferralLinkDetails.fulfilled,
      (state: any, action: any) => {
        state.salesReferralLinkDetailsData = action.payload;
      }
    );
    builder.addCase(
      getSalesReferralLinkDetails.rejected,
      (state: any, action: any) => {
        state.salesReferralLinkDetailsError = action.error.message;
      }
    );
    // Add Sales Referral Link Details For Language
    builder.addCase(
      addSalesReferralLinkDetailsForLanguage.fulfilled,
      (state: any, action: any) => {
        state.addSalesReferralLinkDetailsForLanguageData = action.payload;
        state.isSalesReferralLinkDetailsForLanguageSuccess = true;
      }
    );
    builder.addCase(
      addSalesReferralLinkDetailsForLanguage.rejected,
      (state: any, action: any) => {
        state.addSalesReferralLinkDetailsForLanguageError =
          action.payload || null;
      }
    );

    // Get Sales Network Chart
    builder.addCase(
      getSalesNetworkChart.fulfilled,
      (state: any, action: any) => {
        state.getSalesNetworkChartData = action.payload;
      }
    );
    builder.addCase(
      getSalesNetworkChart.rejected,
      (state: any, action: any) => {
        state.getSalesNetworkChartError = action.error.message;
      }
    );
    // Get Sales Rebate Details
    builder.addCase(
      getSalesRebateDetails.fulfilled,
      (state: any, action: any) => {
        state.rebateSalesDetailsData = action.payload;
      }
    );
    builder.addCase(
      getSalesRebateDetails.rejected,
      (state: any, action: any) => {
        state.rebateSalesDetailsError = action.error.message;
      }
    );
  },
});

export default SalesDashboardReducer.reducer;
